<a *ngIf="this._exchangePrice != null" routerLink="/cryptos/{{this._exchangePrice?.baseCurrency | lowercase}}">
  <div class="cryptosummarybox">
    <div>
      <div class="div-block-37">
        <div class="div-block-38"><img *ngIf="this._exchangePrice != null" src="/assets/icons/currencies/color/{{this._exchangePrice?.baseCurrency | lowercase}}.svg" loading="lazy" class="w-5"></div>
        <div class="text-block-42">{{product?.name}}</div>
      </div>
      <div class="image-6">
        <img src="{{imageBaseUrl}}/charts/1/2/{{exchangePrice?.baseCurrency}}/{{exchangePrice?.quoteCurrency}}.svg?stroke=1&width=115&height=39&color=e8e4ff" loading="lazy" class="image-6">
      </div>
    </div>
    <div class="div-block-39">
      <stock-rate [style]="1" [exchangePrice]="exchangePrice"></stock-rate>
      <div class="text-block-43"><exchange-price [animatePriceChange]="false" [useCompactNotation]="true" [exchangePrice]="exchangePrice"></exchange-price></div>
    </div>
</div>
</a>
